const computeTimezones = () => {
    if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
        try {
            return Intl.supportedValuesOf("timeZone").slice().sort();
        } catch {
            return ["UTC"];
        }
    }
    return ["UTC"];
};

export const TIMEZONES = computeTimezones();
